require('../step.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const {
    ACCOUNT_CANCEL_CHECKS_LOST,
    ACCOUNT_CANCEL_CHECKS_STOLEN,
    ACCOUNT_CANCEL_CHECKS_DETERIORATED,
    FIRST_STEP
} = require('constants/index');
// @actions
const accountCancelChequebookActions = require('actions/accountCancelChequebook');
// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
// @commons
const { OKMessage } = require('commonsComponents/OKMessage');

class AccountCancelChequebookStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { accountId } = this.props;
        this.props.requestCheques(accountId);
    }

    render() {
        const { immAccountsCheques, accountId } = this.props;
        const immCheques = immAccountsCheques.get(accountId);
        let content;

        if (immCheques && !immCheques.get('loading')) {
            const { immAccountCancelChequebook, chequebookIndex, handleMotiveChange } = this.props;
            const chequeId = immCheques.get('byOrder').get(chequebookIndex);
            const immCheque = immCheques.get('byId').get(chequeId);
            const chequesList = `${immCheque.get('initialNum')} - ${immCheque.get('finalNum')}`;
            const errorMessage = immAccountCancelChequebook.getIn(['steps', 0, 'showError']) ? (
                <OKMessage type="warning">
                    <FormattedText value="accountCancelChequebook-errorUnselectedOption" />
                </OKMessage>
            ) : null;
            content = (
                <article className="account-cancel-chequebook-step">
                    <header className="account-cancel-chequebook-step__header">
                        <h5 className="account-cancel-chequebook-step__title">
                            <FormattedText value="accountCancelChequebook-firstStepTitle" />
                        </h5>
                        {errorMessage}
                    </header>
                    <section className="account-cancel-chequebook-step__content">
                        <h6 className="account-cancel-chequebook-step__subtitle">
                            <FormattedText value="accountCancelChequebook-firstStepSelectedChequesSubtitle" />
                        </h6>
                        <span className="account-cancel-chequebook-step__text">
                            {chequesList}
                        </span>
                        <h6 className="account-cancel-chequebook-step__subtitle">
                            <FormattedText value="accountCancelChequebook-firstStepReasonSubtitle" />
                        </h6>
                        <RadioButtonGroup
                            name="motive"
                            idPrefix="cancelChequebookMotiveRadio"
                            selectedValue={immAccountCancelChequebook.get('steps').get(FIRST_STEP).get('motive')}
                            onChange={handleMotiveChange}
                            className="account-cancel-chequebook-step__radio-group"
                        >
                            <RadioButton label={formatText('accountCancelChequebook-deterioration')} value={ACCOUNT_CANCEL_CHECKS_DETERIORATED} className="block-step__radio" />
                            <RadioButton label={formatText('accountCancelChequebook-loss')} value={ACCOUNT_CANCEL_CHECKS_LOST} className="block-step__radio" />
                            <RadioButton label={formatText('accountCancelChequebook-theft')} value={ACCOUNT_CANCEL_CHECKS_STOLEN} className="block-step__radio" />
                        </RadioButtonGroup>
                        <div className="account-cancel-chequebook-step__warning-text">
                            <OKMessage type="error">
                                <FormattedText value="accountCancelCheques-warningTextChequebook" />
                            </OKMessage>
                        </div>
                    </section>
                </article>
            );
        } else {
            content = <LoadingSection />;
        }

        return content;
    }
}

AccountCancelChequebookStep1.propTypes = {
    immAccountCancelChequebook: PropTypes.object.isRequired,
    immAccountsCheques: PropTypes.object.isRequired,
    requestCheques: PropTypes.func.isRequired,
    accountId: PropTypes.string.isRequired,
    chequebookIndex: PropTypes.string.isRequired,
    handleMotiveChange: PropTypes.func.isRequired
};

module.exports.constructor = AccountCancelChequebookStep1;
module.exports.AccountCancelChequebookStep1 = connect(
    null,
    {
        handleMotiveChange: accountCancelChequebookActions.setMotive
    }
)(AccountCancelChequebookStep1);